import React, { useState, useEffect } from "react";
import "./notfound.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = (props) => {
  const { t } = useTranslation(["translation"]);
  const [code, SetCode] = useState("404");
  const [msg, SetMsg] = useState(t("label_404"));

  useEffect(() => {
    if (!!props.code) {
      SetCode(props.code);
    }
    if (!!props.message) {
      SetMsg(props.message);
    }
  }, [props.code, props.message]);
  return (
    <div className="notfound">
      <h3>{code}</h3>
      <p>{msg}</p>
      {!props?.match.params.AppId ? (
        <Link className="btn btn-hover" to={"/"}>
          {t("btn_Return_Home")}
        </Link>
      ) : (
        <Link className="btn btn-hover" to={"/"}>
          {t("btn_Return_Home")}
        </Link>
      )}
    </div>
  );
};

export default NotFound;
